export const stripHTML = (myString) => {
    const el = document.createElement("div");
    el.innerHTML = myString;
    return el.textContent || el.innerText || "";
};
